import { faTrashRestore } from '@fortawesome/pro-regular-svg-icons';
import React, { useCallback } from 'react';
import { projectsApiService } from '../../../../../graphql/projects/projectsApiService';
import DataTableToolbarButton from '../../../../voxel/DataTableToolbar/DataTableToolbarButton';
import { KeywordTableState } from '../logic/useKeywordTableState';

export interface UnarchiveButtonProps {
  selectedCount?: number;
  tableState: KeywordTableState;
  reloadKeywords: () => Promise<unknown>;
  selectionActive?: boolean;
}

export const UnarchiveButton: React.FC<UnarchiveButtonProps> = ({
  tableState,
  reloadKeywords,
  selectedCount,
  selectionActive
}) => {
  const unarchiveKeywordsMutation = projectsApiService.mutations.projects.useUnarchiveKeywords();
  const handleUnarchiveKeywords = useCallback(
    (event: React.MouseEvent<HTMLButtonElement>) => {
      event.stopPropagation();
      unarchiveKeywordsMutation({
        keywordQuery: {
          filtering: tableState.backendFilterState,
          selecting: tableState.backendSelectionState,
        },
      })
        .then(reloadKeywords)
        .then(tableState.handleResetSelection);
    },
    [tableState.backendFilterState, tableState.selectionState, reloadKeywords]
  );

  return (
    <DataTableToolbarButton
      tooltip={'Unarchive selected keywords'}
      iconProp={faTrashRestore}
      onClick={(event) => {
        handleUnarchiveKeywords(event);
      }}
      disabled={!(selectedCount > 0)}
      effect={selectionActive ? 'primary' : undefined}
      effectAnimate={false}
    />
  );
};

export default UnarchiveButton;
